export default __webpack_public_path__ + "static/media/img-0658-lithuania-half-face.218bdbad.png";